<div fxLayoutAlign="center center" class="main-header"><h2 style="text-align: center">UWC Online Quotations & Pro-forma Invoices</h2></div>
<div fxLayoutAlign="center center">
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" class="main-button-wrapper"> 
        <div fxLayoutAlign="center center" class="main-button-container">
            <button mat-button class="main-button" (click)="proceed(1)">
                <span>South African Student</span>
            </button>
            <button mat-button (click)="showMap(1)">
                <mat-icon>help</mat-icon>
            </button>
        </div>
        <div fxLayoutAlign="center center" class="main-button-container">
            <button mat-button class="main-button" (click)="proceed(2)">
                <span>Non South African ID Holders</span>
            </button>
            <button mat-button (click)="showMap(2)">
                <mat-icon>help</mat-icon>
            </button>
        </div>
        <div fxLayoutAlign="center center" class="main-button-container">        
            <button mat-button class="main-button" (click)="proceed(3)">
                <span>Overseas International Student</span>
            </button>
            <button mat-button (click)="showMap(3)">
                <mat-icon>help</mat-icon>
            </button>
        </div>
        <div class="pg-label-container" fxLayoutAlign="center center">
            <mat-label class="pg-label">Masters and PHD students requiring quotations or pro-forma invoices for levy charges and or 
                affiliation fees must email <a href="mailto:studaccount@uwc.ac.za" target="_blank">studaccount@uwc.ac.za</a></mat-label>
        </div>
    </div>
</div>
